import { Routes, Route } from 'react-router-dom'

// Layout components
import BusinessOwnerRoutes from './BusinessOwnerRoutes'
import SystemAdminRoutes from './SystemAdminRoutes'
import MonitorRoutes from './MonitorRoutes'
import BusinessEmployeeRoutes from './BusinessEmployeeRoutes'
import BusinessCashierRoutes from './BusinessCashierRoutes'

// Page components
import HomePage from '../pages/HomePage'
import LoginPage from '../pages/auth/LoginPage'
import RegisterPage from '../pages/auth/RegisterPage'
import MenuPage from '../pages/menu/MenuPage'
import NotFoundPage from '../pages/errors/NotFoundPage'
import AccessDeniedPage from '../pages/errors/AccessDeniedPage'
import { AppRoute } from '../core/config/app-routes'


export default function AppRoutes() {
  return (
    <Routes>
      {/* Public routes */}
      <Route path={AppRoute.HOME_ROUTE} element={<HomePage />} />
      <Route path={AppRoute.LOGIN_ROUTE} element={<LoginPage />} />
      <Route path={AppRoute.REGISTER_ROUTE} element={<RegisterPage />} />
      <Route path={`${AppRoute.MENU_ROUTE(':slug')}/*`} element={<MenuPage />} />
      
      {/* Error routes */}
      <Route path={AppRoute.ACCESS_DENIED_ROUTE} element={<AccessDeniedPage />} />
      
      {/* Admin routes */}
      {SystemAdminRoutes()}
      
      {/* Monitor routes */}
      {MonitorRoutes()}
      
      {/* Business routes */}
      {BusinessOwnerRoutes()}
      
      {/* Business Employee routes */}
      {BusinessEmployeeRoutes()}
      
      {/* Business Cashier routes */}
      {BusinessCashierRoutes()}
      
      {/* 404 page */}
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  )
}
